import React, { useCallback, useMemo } from "react";
import { SVGIcon2 } from "../../components/common/SVGIconV2";
import { TrackingInfo } from "../../components/tracking/TrackingInfoHeader";
import { OpenControlCenterSource } from "../../components/ControlCenter/enums";
import { performAction } from "../../utils/actionUtils";
import { Actions } from "../../constants";
import PropTypes from "prop-types";

const DepositLimitsHeaderButton = props => {
  const { dataLabel } = props;

  const componentTrackingInfo = useMemo(
    () =>
      Object.assign(
        {
          dataCategory: "default",
          dataAction: "click"
        },
        TrackingInfo,
        { dataLabel }
      ),
    []
  );

  const onClick = useCallback(() => {
    const launchInfoOverrides = {
      launchInfo: {
        appSpecificParameters: {
          source: OpenControlCenterSource.Lobby,
          deeplink: 4
        }
      }
    };
    performAction(Actions.openControlCenterFull, launchInfoOverrides);
  });

  return (
    <a
      onClick={onClick}
      data-category={componentTrackingInfo.dataCategory}
      data-action={componentTrackingInfo.dataAction}
      data-label={componentTrackingInfo.dataLabel}
      data-value=""
    >
      <SVGIcon2 iconName="depositLimit" />
    </a>
  );
};

DepositLimitsHeaderButton.propTypes = {
  dataLabel: PropTypes.string.isRequired
};

export default React.memo(DepositLimitsHeaderButton);
